module.exports = __webpack_public_path__ + "static/media/5DPO12.43c4c96a.jpg";